import {Overlay as StyledOverlay} from './styles';
import {OverlayProps} from './types';

const Overlay: React.FC<OverlayProps> = (props) => <StyledOverlay {...props} />;

export default Overlay;
